export default __webpack_public_path__ + "static/media/lava-ui-tablet-main.b6d203b5.webp";